.themableModule {
    composes: repeater from "../../styles/layout.module.scss";
    grid-column: margin;
}
